import {slugify} from '../../helpers';
import api, {graphqlQueryBuild} from '../../services/api';
import {selectAgeRating} from '../reducers';

export const LOAD_SHOWS = 'LOAD_SHOWS';
export const LOAD_SHOW_DETAILS = 'LOAD_SHOW_DETAILS';

export const loadShows = () => {
    return async (dispatch, getState) => {
        let {recommendation} = getState();
        let ageRating = selectAgeRating(getState());
        let rating =
            ageRating === 12
                ? 'UP_TO_12'
                : ageRating === 10
                ? 'UP_TO_10'
                : 'ALL';

        dispatch({
            type: LOAD_SHOWS,
            payload: {loading: true, shows: undefined},
        });

        let query = graphqlQueryBuild(
            'shows',
            `id title image externalId`,
            `showEmpty: false, age:${rating}`,
        );

        let shows_response = await api
            .get('', {
                params: {
                    query,
                },
            })
            .then(res => res)
            .catch(err => err.response);

        if (shows_response.data?.data?.shows) {
            let {shows} = shows_response.data.data;

            shows = shows.reduce((acc, curr) => {
                if (
                    acc.findIndex(
                        item => !!curr.title && item.title === curr.title,
                    ) >= 0
                ) {
                    let duplicatedShowIndex = acc.findIndex(
                        item => item.title === curr.title,
                    );
                    acc[duplicatedShowIndex] = {
                        ...acc[duplicatedShowIndex],
                        ...curr,
                    };

                    return acc;
                } else {
                    return [...acc, curr];
                }
            }, []);

            shows_response.data.data.shows = shows;
        }

        dispatch({
            type: LOAD_SHOWS,
            payload: {
                loading: false,
                error: shows_response.status !== 200,
                shows: shows_response.data?.data?.shows || [],
                recommendation,
            },
        });

        return shows_response;
    };
};

export const loadShowDetails = show_id => {
    return async (dispatch, getState) => {
        let query = graphqlQueryBuild(
            'show',
            `
            id
            title
            image
            description
            genres

            seasons (showEmpty: false) {
                id
                number
                type
                
                vods {
                    id
                    title
                    image
                    duration
                    episode
                    season
                    description
                    contentRating
                    show {
                        id
                        title
                    }
                }
            }`,
            `title: "${slugify(show_id)}"`,
        );

        let show_response = await api
            .get('', {
                params: {
                    query,
                },
            })
            .then(res => res)
            .catch(err => err.response);

        if (
            show_response.data?.data?.show &&
            show_response.data?.data?.show.seasons?.length
        ) {
            let {show} = show_response.data.data;

            show.seasons = show.seasons?.reduce((acc, curr) => {
                if (
                    acc.findIndex(
                        item => !!curr.number && item.number === curr.number,
                    ) >= 0
                ) {
                    let duplicatedShowIndex = acc.findIndex(
                        item => item.number === curr.number,
                    );
                    acc[duplicatedShowIndex] = {
                        ...acc[duplicatedShowIndex],
                        ...curr,
                        vods: [
                            ...acc[duplicatedShowIndex].vods,
                            ...curr.vods,
                        ].sort((a, b) => a.episode - b.episode),
                    };

                    return acc;
                } else {
                    return [...acc, curr];
                }
            }, []);

            show_response.data.data.show = show;
        }

        dispatch({
            type: LOAD_SHOW_DETAILS,
            payload: {
                loading: false,
                error: show_response.status !== 200,
                show: show_response.data?.data?.show || null,
            },
        });

        return show_response;
    };
};
